import { EMPTY_OBJECT } from '../../../../constants/common'

import { formatProps } from './ComponentUsage.utils'

import * as styles from './ComponentUsage.module.css'

function ComponentUsage({
  Element = 'pre',
  className = styles.ComponentUsage,
  name,
  value = EMPTY_OBJECT,
  ...elementProps
}) {
  return (
    <Element {...elementProps} className={className}>
      {`<${name} `}
      {formatProps(value).map((prop, index) => (
        <div className={styles.prop} key={index}>
          {prop}
        </div>
      ))}
      {`/>`}
    </Element>
  )
}

export default ComponentUsage
